import { readTouchstone, touchstoneCodec, } from '@nanovnaweb/formats';
import { asyncIterableFromArray } from '../util/async-iter.js';
export function parseTouchstoneImport(blob, opts) {
    return readTouchstone(blob, opts);
}
export function buildTouchstoneExport(trace) {
    return touchstoneCodec.write(asyncIterableFromArray([trace]));
}
//# sourceMappingURL=touchstone-bridge.js.map